// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__3pcM4","grid":"Footer_grid__2VQUg","header":"Footer_header__1TN6x","container":"Footer_container__1ap14","gridOne":"Footer_gridOne__BjWIs"};